import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Chip,
    Container,
    Divider,
    Link,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    FormHelperText,
    Avatar,
    Checkbox,
    Autocomplete
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import { useFormik } from 'formik';
import * as yup from 'yup';
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown.svg";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import ResetPasswordDialog from "../../../../components/kpi/ResetPasswordDialog";
import CopyDialog from "../../../../components/kpi/CopyDialog";
import * as Util from "../../../../services/global.service";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { detailJobData } from "../../../../actions/admin";
import securityService from "../../../../services/security.service";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';


const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
};

const EditResetPassword = (props) => {
    const { t } = useTranslation();

    useEffect(() => {
    }, []);

    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        input: {
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },

        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        disabled: {
            '& div > input': {
                height: '8px',
                position: "relative"
            },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            }
        },
        expandableIcon: {
            border: "1px solid #DADADA",
            // padding:" 8px",
            width: '20px',
            height: '20px',
            borderRadius: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: '.3s',
            transform: "rotate(90deg)",
            '&.active': {
                transform: "rotate(-90deg)",
            }
        },
        styleTag: {
            '& div > .MuiOutlinedInput-root': {
                '& .MuiChip-root': {
                    backgroundColor: "#5DA196",
                    color: "#ffffff",
                    borderRadius: "3px",
                    '& .MuiChip-deleteIcon': {
                        color: "#ffffff",
                    }
                },
            },
        }

    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const classes = useStyles();
    const dispatch = useDispatch();
    let { serial } = useParams();
    const [Data, setData] = React.useState({});
    const [status, setStatus] = React.useState(true);
    const [statusLockUser, setStatusLockUser] = React.useState(false);
    const [iconIcon, setIconIcon] = React.useState("");
    const [btnIcon, setBtnIcon] = React.useState("");
    const [colorIcon, setColorIcon] = React.useState("");
    const [openIcon, setOpenIcon] = React.useState(false);
    const [displayInactive, setDisplayInactive] = React.useState(false);
    const [backgroundColorValue, setBackgroundColorValue] = React.useState("#5DA196");
    const [backgroundColorStatus, setBackgroundColorStatus] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [isCollapse, setCollapse] = React.useState(false);
    const [valueSerial, setValueSerial] = React.useState('');
    const [valueRole, setValueRole] = React.useState([]);
    const [configuration, setConfiguration] = React.useState({})
    const [edit, setEdit] = React.useState(false);
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const handleStatus = () => {
        setStatus(!status)
    }
    const handleStatusLockUser = () => {
        setDiscardLockUserDialog(true)
    }
    useEffect(() => {
        getDetailUser()
        getListRole()
    }, []);
    const getDetailUser = () => {
        securityService.detailUser(serial).then(
            (response) => {
                setData(response?.data?.user_role)
                setConfiguration(response?.data?.configuration)
                setStatusLockUser(response?.data?.user_role?.is_lock)
                setEdit(false)
            },
        )
    }
    const getListRole = () => {
        securityService.listRolePermissionUser().then(
            (response) => {
                setValueRole(response.data.permission_role)
            },
        )
    }

    useEffect(() => {
        if (Util.formatData(Data?.permission_role, false) !== false && Data.permission_role.length > 0 && Util.formatData(valueRole, false) !== false && valueRole.length > 0) {
            let dataValueRole = []
            for (let index = 0; index <= Data.permission_role.length - 1; index++) {
                let findData = valueRole.filter((rs) => rs?.serial === Data?.permission_role[index]?.serial)
                dataValueRole = [...dataValueRole, ...findData]
            }
            formik.setFieldValue("role", Util.formatData(dataValueRole, []))
        }
    }, [valueRole, Data]);
    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));

    const IOSSwitchLockUser = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#CC6058',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));

    const [discardLockUserDialog, setDiscardLockUserDialog] = React.useState(false);
    const handleDiscardLockUserDialog = (value) => {
        setDiscardLockUserDialog(value)
    };
    const handleDiscardLockUserChangeConfirm = () => {
        setStatusLockUser(!statusLockUser)
        handleDiscardLockUserDialog(false)
    };

    const [isResetPasswordDialogOpen, openResetPasswordDialog] = React.useState(false);

    const handleResetPasswordDialog = (value) => {
        openResetPasswordDialog(value)
    }
    const [isSuccessResetPassword, setIsSuccessResetPassword] = React.useState(false);
    const [isSuccessResetPasswordRamdom, setIsSuccessResetPasswordRamdom] = React.useState(false);
    const [isWarningResetPassword, setIsWarningResetPassword] = React.useState(false);
    const [passwordRamdom, setPasswordRandom] = React.useState("");

    const [successText, setSuccessText] = React.useState("")
    const ResetSuccess = (data, type) => {
        if (type === "random") {
            setSuccessText(t('security.resetPasswordSuccessfully'))
            setIsSuccessResetPasswordRamdom(true)
            setPasswordRandom(data?.password)
        } else if (type === "warning") {
            setSuccessText(t('security.pleaseWaitResetPasswordAgain'))
            openResetPasswordDialog(false)
            setIsWarningResetPassword(true)
        } else {
            setSuccessText(t('security.resetPasswordSuccessfully'))
            setIsSuccessResetPassword(true)
        }

    }

    // const validationSchema = yup.object({
    //     code: yup.string().required(t('admin.inputForm.msgError.code')),
    //     nameEN: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
    //     // nameTH: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),

    // });
    const formik = useFormik({
        initialValues: {
            // status: "",
            // is_locked: "",
            role: []
        },
        enableReinitialize: true,
        // validationSchema: validationSchema,
        onSubmit: (values) => {
            submit(values)
            // openSuccessAddDialog(true)
        },
    });

    const handleSubmit = () => {
        formik.submitForm()
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }

    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        navigate('/admin/security', { replace: false });
    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleDirect = () => {
        openSuccessAddDialog(false)
        navigate('/admin/security', { replace: false });
    }
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };

    const submit = (data) => {
        let dataRole = []
        for (let index = 0; index <= data?.role.length - 1; index++) {
            dataRole.push(data?.role[index].serial)
        }
        let dataRoleAuto = Data.permission_role.filter((rs) => rs.role_type === "auto")
        let dataRoleAutoMain = []
        for (let idx = 0; idx <= dataRoleAuto.length - 1; idx++) {
            dataRoleAutoMain.push(dataRoleAuto[idx].serial)
        }
        let dataList = [...dataRole, ...dataRoleAutoMain]
        securityService.editUser({
            serial: serial,
            status: Data?.status,
            is_locked: statusLockUser,
            role: Util.formatData(dataList, [])
        }, serial).then(
            (response) => {
                openSuccessAddDialog(true)
            },
        ).catch(() => {
            handleOpenFailedMessageDialog()
        })
    }
    useEffect(() => {
        if (edit === false) {
            setEdit(true)
        }
    }, [formik.values, statusLockUser]);


    const formikChangeRole = (val, field) => {
        formik.setFieldValue(field, val)
    }

    return (
        <>
            <Helmet>
                <title>ADMIN | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/security')}>{t('security.security')}</span> / <span style={styles.end} >{t('security.editUser')}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" >
                            <Typography variant="h1" fontSize={36} lineHeight="53.82px" fontWeight="500" color="#404349">
                                {t('security.editUser')}
                            </Typography>

                            {configuration?.forget_password &&
                                <Box display="flex" alignItems="center">
                                    {Data?.data_as_of !== undefined && Data?.data_as_of !== null && Data?.data_as_of !== "" ?
                                        <Typography fontSize={16} lineHeight="23.92px" fontWeight="400" color="#A3A3A3">
                                            {t('admin.label.dateAsOf')}: {Util.dateDayTimeFormatAdmin(Data?.data_as_of)}
                                        </Typography>
                                        :
                                        <Typography fontSize={16} lineHeight="23.92px" fontWeight="400" color="#A3A3A3">
                                            {t('admin.label.dateAsOf')}: -
                                        </Typography>
                                    }
                                    <Button onClick={() => handleResetPasswordDialog(true)} size="large" variant="contained-black" sx={{ textTransform: "none", marginLeft: "30px" }}>{t('security.resetPassword')}</Button>
                                </Box>
                            }

                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">
                            <Grid container item>
                                <Paper elevation={6} sx={{ 'border-radius': '10px', width: '100%' }} classes={{ root: classes.error }}>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "50px 0px 20px 30px" }}>
                                        <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={24} lineHeight="26.4px" fontWeight={500} color="#404349">{t('security.user')}</Typography>
                                            <Divider sx={{ width: "100%", paddingTop: "10px" }} />
                                        </Grid>
                                    </Grid>
                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                        <Avatar
                                            src={Util.formatData(Data?.photo, "")}
                                            sx={{
                                                width: 150,
                                                height: 150,
                                            }}
                                        />
                                    </Box>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "70px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500} color="#404349">{t('admin.inputForm.employeeID')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px" color="#404349">{Util.formatData(Data?.code, "")} </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" display="flex" fontWeight={500} color="#404349">{t('admin.inputForm.status')} </Typography>
                                            <Box sx={{ paddingTop: "16px", height: "100%", "max-height": "55px", display: "flex", "align-items": "center" }}>
                                                <FormGroup >
                                                    <FormControlLabel
                                                        sx={{ m: 0, "pointer-events": "none", color: "#404349" }}
                                                        control={<IOSSwitch checked={Data?.status === "active" ? true : false} onChange={() => handleStatus()} />}
                                                        label={Data?.status === "active" ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                    />
                                                </FormGroup>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500} color="#404349">{t('admin.inputForm.userName')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px" color="#404349">{Util.formatData(Data?.username, "")} </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500} color="#404349">{t('admin.inputForm.title')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px" color="#404349">
                                                    {Util.formatData(Data?.title_en, "")} {Data?.title_en !== undefined && Data?.title_en !== null && Data?.title_en !== "" && Data?.title_th !== undefined && Data?.title_th !== null && Data?.title_th !== "" ? " / " : ""} {Util.formatData(Data?.title_th, "")}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500} color="#404349">{t('admin.inputForm.nameEN')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px" color="#404349">{Util.formatData(Data?.first_name_en, "")} </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500} color="#404349">{t('admin.inputForm.lastNameEN')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px" color="#404349">{Util.formatData(Data?.last_name_en, "")}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500} color="#404349">{t('admin.inputForm.nameTH')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px" color="#404349">{Util.formatData(Data?.first_name_th, "")} </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500} color="#404349">{t('admin.inputForm.lastNameTH')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px" color="#404349">{Util.formatData(Data?.last_name_th, "")}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 0px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500} color="#404349">{t('admin.inputForm.startDate')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px" color="#404349">{Util.formatData(Util.dateDayFormat(Data?.start_date), "")} </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500} color="#404349">{t('admin.inputForm.endDate')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px" color="#404349">{Util.formatData(Util.dateDayFormat(Data?.end_date), "")}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" sx={{ padding: "20px 30px 20px 30px" }}>
                                        <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                                            <Divider sx={{ width: "100%" }} />
                                        </Grid>
                                    </Grid>

                                    {configuration?.forget_password &&
                                        <Box sx={{ width: "100%", margin: "0 40px 30px", ".MuiFormControl-root": { "margin-top": "7px" } }}>
                                            <Box sx={{ "margin-top": "7px", height: "auto", display: "flex", "align-items": "center" }}>
                                                <FormGroup >
                                                    <FormControlLabel
                                                        sx={{ m: 0 }}
                                                        control={<IOSSwitchLockUser checked={statusLockUser} onChange={() => handleStatusLockUser()} />}
                                                        // label={status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                        label={
                                                            <Box pl="15px">
                                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                                    <Typography fontSize={18} lineHeight="26.91px" fontWeight={500} color="#404349">
                                                                        {t('security.lockUser')}
                                                                    </Typography>
                                                                    {statusLockUser ?
                                                                        <Typography fontSize={18} lineHeight="26.91px" fontWeight={400} color="#CC6058" pl="10px">
                                                                            ({t('security.userLocked')})
                                                                        </Typography>
                                                                        : null
                                                                    }
                                                                </Box>
                                                                <Box>
                                                                    <Typography fontSize={16} lineHeight="23.92px" fontWeight={400} color="#AAAAAA">
                                                                        {t('security.lockUserDesc')}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        }
                                                    />
                                                </FormGroup>
                                            </Box>
                                        </Box>
                                    }

                                </Paper>
                            </Grid>
                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">
                            <Grid container item>
                                <Paper elevation={6} sx={{ 'border-radius': '10px', width: '100%' }} classes={{ root: classes.error }}>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "50px 0px 20px 30px" }}>
                                        <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={24} lineHeight="26.4px" fontWeight={500} color="#404349">{t('security.role')}</Typography>
                                            <Divider sx={{ width: "100%", paddingTop: "10px" }} />
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" sx={{ padding: "0px 0px 20px 30px" }}>
                                        <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500} color="#404349">{t('security.role')}</Typography>
                                            <Box mt="10px" mr="30px">
                                                <Autocomplete
                                                    multiple
                                                    id="checkboxes-tags-demo"
                                                    size="small"
                                                    fullWidth
                                                    options={valueRole}
                                                    disableCloseOnSelect
                                                    value={formik.values.role}
                                                    onChange={(event, newValue) => {
                                                        formikChangeRole(newValue, "role")
                                                    }}
                                                    classes={{ root: classes.styleTag }}
                                                    getOptionLabel={(option) => `${option?.code} ${Util.formatData(option?.code, false) !== false && Util.formatData(option?.name, false) !== false ? " - " : ""} ${option?.name}`}
                                                    renderOption={(props, option, { selected }) => (
                                                        <li {...props}>
                                                            <Checkbox
                                                                icon={icon}
                                                                checkedIcon={checkedIcon}
                                                                style={{ marginRight: 8 }}
                                                                checked={formik.values.role.filter((rs) => rs?.serial === option?.serial).length > 0}
                                                            />
                                                            <span style={{ display: "flex", width: "100%", alignItems: "center" }}>
                                                                <span style={{ width: "50%", pr: "20px", color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "16px" }}>{option?.code} {Util.formatData(option?.code, false) !== false && Util.formatData(option?.name, false) !== false ? " - " : ""} {option?.name}</span>
                                                                <span style={{ width: "50%", pr: "20px", color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "16px" }}>{option?.description}</span>
                                                            </span>
                                                            {/* {option?.value === undefined ? `${option?.name} - ${option?.description}` : option?.label} */}
                                                        </li>
                                                    )}
                                                    style={{ width: "100%", color: "#404349" }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder={`Select Role`}
                                                            InputLabelProps={{
                                                                ...params.inputProps,
                                                                shrink: true,
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Box>
                                            <Grid container lg={12} md={12} xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 0px 0px", flexFlow: "row wrap" }}>
                                                {Data?.permission_role !== undefined && Data?.permission_role !== null && Data?.permission_role.length > 0 ?
                                                    Data?.permission_role.map((row, index) => (
                                                        row?.role_type === "auto" ?
                                                            <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "25px !important" }}>
                                                                <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500} color="#404349">{t('security.autoRole')}</Typography>
                                                                <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                                    <Typography fontSize={16} lineHeight="23.92px" color="#404349">
                                                                        {Util.formatData(row?.code, "")} {row?.code !== undefined && row?.code !== null && row?.code !== "" && row?.name !== undefined && row?.name !== null && row?.name !== "" ? " - " : ""} {Util.formatData(row?.name, "")}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>
                                                            : null
                                                    ))
                                                    : null
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Paper>
                                <Grid container mt={3} mb={3} >
                                    <Grid item xs display="flex" flexDirection="row-reverse">
                                        <Box sx={{ width: "100px" }}>
                                            <Button disabled={edit === true ? false : true} onClick={handleSubmit} color="primary" variant="contained" fullWidth sx={{ textTransform: "none" }}>
                                                {t('label.save')}
                                            </Button>
                                        </Box>
                                        <Box mr={2} sx={{ width: "100px" }}>
                                            <Button color="black" variant="outlined" fullWidth onClick={handleCancel} sx={{ textTransform: "none" }}>
                                                {t('label.cancel')}
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <ConfirmDialog open={discardLockUserDialog} warning={true} doConfirm={() => handleDiscardLockUserChangeConfirm()} setValue={() => handleDiscardLockUserDialog(false)} title={statusLockUser ? t('security.confirmationOfUnlockUser') : t('security.confirmationOfLockUser')} text={statusLockUser ? t('security.areYouSureToUnlock') : t('security.areYouSureToLock')} />
                    <ResetPasswordDialog open={isResetPasswordDialogOpen} setValue={openResetPasswordDialog} submitReset={ResetSuccess} serial={Data?.serial} email={Data?.email}></ResetPasswordDialog>
                    <MessageDialog open={isSuccessResetPassword} setValue={() => setIsSuccessResetPassword(false)} title={t("label.success")} text={successText} />
                    <MessageDialog open={isWarningResetPassword} setValue={() => setIsWarningResetPassword(false)} title={t("label.warning")} text={successText} type="warning" />
                    <CopyDialog open={isSuccessResetPasswordRamdom} setValue={() => setIsSuccessResetPasswordRamdom(false)} title={t("label.success")} text={successText} password={passwordRamdom} />
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text={t('security.userEditSuccessfully')}
                        page={true}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={t(`security.userEditFail`)}
                    />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
                </Container>
            </Box >
        </>
    )
};
export default EditResetPassword;
